<template>
  <div class="content">
    <div class="user-management">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <Card>
              <template slot="header">
                <div class="row">
                  <div class="col-sm-6">
                    <h5 class="title">All Employees</h5>
                  </div>
                  <div class="col-sm-6" style="display: flex; justify-content: end;">
                    <input v-model="searchTerm" type="text" class="search-input"
                      placeholder="Search by name or email" />
                  </div>
                </div>
              </template>
              <div>
                <CustomTable :columns="tableColumns" :data="filteredUsers">
                  <template #avatar="{ item }">
                    <img style="width: 35px; height: 35px; border-radius: 20px;padding: 2px; border:2px solid gray"
                      :src="item.profile_picture || 'static/img/default-dp.png'" alt="avatar" />
                  </template>

                  <template #username="{ item }">
                    <span :title="item.username">{{ item.username || '-' }}</span>
                  </template>

                  <template #email="{ item }">
                    <span class="truncate-text" :title="item.email">{{ item.email || '-' }}</span>
                  </template>
                  <template #designation="{ item }">
                    <span class="truncate-text" :title="item.designation">{{ item.designation || '-' }}</span>
                  </template>
                  <template #grade="{ item }">
                    <span class="truncate-text" :title="item.grade">{{ item.grade || '-' }}</span>
                  </template>
                </CustomTable>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTable from "src/components/UIComponents/CustomTable.vue";
import Card from "src/components/UIComponents/Cards/Card.vue";
export default {
  components: {
    Card,
    CustomTable
  },
  data() {
    return {
      searchTerm: "", // Store the search term
      tableColumns: [
        { label: "Avatar", key: "avatar", width: 90 },
        { label: "Name", key: "username", sortable: true },
        { label: "Email", key: "email", sortable: true,  width: 250 },
        { label: "Designation", key: "designation", sortable: true },
        { label: "Grade", key: "grade", sortable: true, width: 150},
      ]
    };
  },
  computed: {
    loading() {
      return this.$store.state.loading || false;
    },
    paginatedData: {
      type: Array,
      required: true
    },
    sortKey: {
      type: String,
      default: ''
    },
    sortOrder: {
      type: String,
      default: 'asc'
    }
  },
   computed: {
    loading() {
      return this.$store.state.loading || false;
    },
    filteredUsers() {
      const company = this.$store.state.auth.company;
      const companyUserIds = company.users.map(user => user.uid);
      const allUsers = this.$store.state.auth.allUsers.filter(user =>
        companyUserIds.includes(user.uid)
      );

      // If there's a search term, filter by name or email
      if (this.searchTerm) {
        return allUsers.filter(user => {
          const name = user.username ? user.username.toLowerCase() : "";
          const email = user.email ? user.email.toLowerCase() : "";
          const searchTerm = this.searchTerm.toLowerCase();
          return name.includes(searchTerm) || email.includes(searchTerm);
        });
      }

      return allUsers;
    }
  },
  methods: {
    sortTable(columnKey) {
      if (this.sortKey === columnKey) {
        this.$emit('update:sortOrder', this.sortOrder === 'asc' ? 'desc' : 'asc');
      } else {
        this.$emit('update:sortKey', columnKey);
        this.$emit('update:sortOrder', 'asc');
      }
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/userManagement/EmployeeUserManagement.vue